import { Center, Container, Flex, SimpleGrid, Text } from '@chakra-ui/react';
import React, { FunctionComponent } from 'react';
import { withTranslations } from 'store/translations';

import { Team as TeamModel } from '../../models';
import { AdvancedText, getAdvancedTextContent } from '../common';
import { ContactGroupItem } from './ContactGroupItem';

interface TeamProps {
  model: TeamModel;
}

export const Team: FunctionComponent<TeamProps> = ({ model }) => {
  const { common } = withTranslations();
  const contactItems = model.elements?.contactItems?.linkedItems;
  const advancedTextContent = getAdvancedTextContent(model.elements?.advancedText);

  return (
    <Container pb={{ base: 's', lg: 'm' }} pt='xs'>
      <Text as='h2' color='mountain.base' textStyle={{ base: `mobile.h4`, md: `desktop.h4` }} textAlign='left' pb='xl'>
        {model.elements?.heading?.value}
      </Text>

      <AdvancedText content={advancedTextContent} />

      <Flex
        align='center'
        direction={{ base: 'column', lg: 'row' }}
        gap={{ base: 'xs', lg: '0' }}
        mb={{ base: 's', lg: 'm' }}
      >
        {contactItems?.length ? (
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacingX='200px' spacingY='50px'>
            {contactItems.map((person) => (
              <ContactGroupItem key={person.system.id} model={person} />
            ))}
          </SimpleGrid>
        ) : (
          <Center>
            <Text color='mountain.base' textStyle={{ base: 'mobile.body.medium.s', lg: 'desktop.body.medium.l' }}>
              {common('noResultsFound')}
            </Text>
          </Center>
        )}
      </Flex>
    </Container>
  );
};
